// extracted by mini-css-extract-plugin
export var width100 = "B_w d_w";
export var design3Pos = "B_vg d_0";